import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { WorkItemDetailView } from '@/features/Trainer/WorkItemDetail';

export const Route = createFileRoute('/trainer/batches/$batchId/work-items/$assessmentId')({
  component: WorkItemRoute,
});

function WorkItemRoute() {
  const { batchId, assessmentId } = Route.useParams();

  return (
    <div className="space-y-3">
      {/*
        Back to the queue rather than to browser history: this screen is
        reached from a student's feed and from the queue, and both journeys end
        with the trainer wanting the list of people they were working through.
      */}
      <Button variant="ghost" size="sm" asChild className="-ml-2 h-7 gap-1.5 px-2 text-xs">
        <Link to="/trainer/batches/$batchId/attention" params={{ batchId }}>
          <ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" />
          Back to attention
        </Link>
      </Button>

      <WorkItemDetailView batchId={batchId} assessmentId={assessmentId} />
    </div>
  );
}
